<form class="mc-spring-board">
  <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" mcColor="secondary-invert">
    <mat-tab label="Teams">
      <div class="mc-spring-board">
        <div class="mc-spring-board-header">
          <button #popupTriggerTeams *ngIf="(canEdit$ | async)" type="button" color="primary" [disabled]="savingState.loading$ | async" mat-raised-button [mcPopupTriggerAutoClose]="false" [mcPopupTriggerFor]="addUserTeamsPopup" [mcPopupWidth]="506">
            <div class="mc-d-flex mc-align-items-center">
              <ng-container *ngIf="savingState.loading$ | async; else addUserTeams">Adding User Teams</ng-container>
              <ng-template #addUserTeams>Add User Teams</ng-template>
              &nbsp;
              <mc-dropdown-arrow></mc-dropdown-arrow>
            </div>
          </button>

          <mat-form-field mcColor="secondary" class="mc-form-field">
            <mat-label>Filter User Teams</mat-label>
            <div class="mc-user-access-form-access-user-entity">
              <input #filterUserTeams matInput placeholder="Name" name="filterUserTeam" (keyup)="onFilterUserTeamsKeyUp($event)">
            </div>
          </mat-form-field>
          <mc-filter-bar display="list" [filterable]="licenseUserTeamsList"></mc-filter-bar>
        </div>
        <div class="mc-spring-board-form-body">
          <mc-license-user-teams-list #licenseUserTeamsList [licenseUserId]="licenseUser?.Id" [canEdit]="(canEdit$ | async)" (saved)="onSaved()"></mc-license-user-teams-list>
        </div>
      </div>

      <mc-popup #addUserTeamsPopup (closedStream)="onUserTeamsPopupClosed()">
        <div class="mc-spring-board">
          <div class="mc-spring-board-form-body">
            <mat-form-field mcColor="secondary" class="mc-form-field mc-form-field-compact">
              <mat-label>Add User Teams</mat-label>
              <mc-autocomplete-input #licenseUserTeamsAutoComplete [multiple]="true" [closePopupOnSelection]="true" [triggerPopupOnFocus]="false" placeholder="Type to find teams">
                <mc-teams-select-list mcAutocompleteList [licenseId]="licenseUser?.LicenseId"></mc-teams-select-list>
                <ng-template mcAutocompleteItem let-teamId="item">
                  <mc-team-avatar compact [disabled]="true" [team]="teamId | mcTeamAsync | async" size="small" [truncate]="true"></mc-team-avatar>
                </ng-template>
              </mc-autocomplete-input>
            </mat-form-field>
          </div>
          <div class="mc-spring-board-form-footer">
            <div class="mc-form-buttons">
              <button type="button" mat-stroked-button color="warn" (click)="onCancelUserTeamsClicked()">Cancel</button>
              <button type="button" mat-raised-button color="primary" (click)="onAddUserTeamsClicked()">Add Teams to User</button>
            </div>
          </div>
        </div>
      </mc-popup>
    </mat-tab>

    <mat-tab label="Projects" *ngIf="(canAssignToProjects$ | async)">
      <div class="mc-spring-board">
        <div class="mc-spring-board-header">
          <button #popupTriggerProjects *ngIf="(canEdit$ | async)" type="button" color="primary" [disabled]="savingState.loading$ | async" mat-raised-button [mcPopupTriggerAutoClose]="false" [mcPopupTriggerFor]="addUserProjectsPopup" [mcPopupWidth]="506">
            <div class="mc-d-flex mc-align-items-center">
              <ng-container *ngIf="savingState.loading$ | async; else addUserProjects">Adding User Projects</ng-container>
              <ng-template #addUserProjects>Add User Projects</ng-template>
              &nbsp;
              <mc-dropdown-arrow></mc-dropdown-arrow>
            </div>
          </button>

          <mat-form-field mcColor="secondary" class="mc-form-field">
            <mat-label>Filter User Projects</mat-label>
            <div class="mc-user-access-form-access-user-entity">
              <input #filterUserProjects matInput placeholder="Name" name="filterUserProject" (keyup)="onFilterUserProjectsKeyUp($event)">
            </div>
          </mat-form-field>
          <mc-filter-bar display="list" [filterable]="licenseUserProjectsList"></mc-filter-bar>
        </div>
        <div class="mc-spring-board-form-body">
          <mc-license-user-projects-list #licenseUserProjectsList [licenseUserId]="licenseUser?.Id" [canEdit]="(canEdit$ | async)" (saved)="onSaved()"></mc-license-user-projects-list>
        </div>
      </div>

      <mc-popup #addUserProjectsPopup (closedStream)="onUserProjectsPopupClosed()">
        <div class="mc-spring-board">
          <div class="mc-spring-board-form-body">
            <mat-form-field mcColor="secondary" class="mc-form-field mc-form-field-compact">
              <mat-label>Add User Projects</mat-label>
              <mc-autocomplete-input #licenseUserProjectsAutoComplete [multiple]="true" [closePopupOnSelection]="true" [triggerPopupOnFocus]="false" placeholder="Type to find projects">
                <mc-projects-select-list mcAutocompleteList [licenseId]="licenseUser?.LicenseId" [projectStatuses]="projectStatuses"></mc-projects-select-list>
                <ng-template mcAutocompleteItem let-projectId="item">
                  <mc-project-avatar compact [disabled]="true" [project]="projectId | mcProjectAsync | async" size="small" [truncate]="true"></mc-project-avatar>
                </ng-template>
              </mc-autocomplete-input>
            </mat-form-field>
          </div>
          <div class="mc-spring-board-form-footer">
            <div class="mc-form-buttons">
              <button type="button" mat-stroked-button color="warn" (click)="onCancelUserProjectsClicked()">Cancel</button>
              <button type="button" mat-raised-button color="primary" (click)="onAddUserProjectsClicked()">Add Projects to User</button>
            </div>
          </div>
        </div>
      </mc-popup>
    </mat-tab>

  </mat-tab-group>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
  </div>

  <!--Saving State-->
  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>